import { render, staticRenderFns } from "./EditRatePlan.vue?vue&type=template&id=1269f566&scoped=true"
import script from "./EditRatePlan.vue?vue&type=script&lang=js"
export * from "./EditRatePlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1269f566",
  null
  
)

export default component.exports